import axios from 'axios';
const commonPath = `/api/activity/weixinActivity/goodsActivityStatistics/`;
const axiosConf = {
    disableLoading: true,
    disableAlert: true,
};
/**
 * 商品营销活动
 * @param statistics_type
 * @param activity_type
 * @param activity_id
 */
export async function addStatisticsA(statistics_type, activity) {
    let requestData;
    if (activity.activity_type === 'group') {
        requestData = {
            activityId: activity.id,
            type: statistics_type,
            activityType: activity.activity_type,
        };
    }
    if (!requestData)
        return;
    await axios.post(`${commonPath}statistics`, requestData, axiosConf);
}
